module.exports = __webpack_public_path__ + "img/AFRICA_CAKES_AND_PASTRIES.fe7c0be0.png";